<template>
  <div class="head_line">
    <div class="container top hidden-sm hidden-xs">
      <div class="top_location">
        <img class="loc_icon" src="../../static/loca.png" />{{ city }}
        <span class="change_city" @click="selectcity">切换城市 </span>
      </div>
      <div class="top_user">
        <div class="user_center" v-if="token == null">
          <router-link :to="{ name: 'login' }"
            ><span class="style">你好，请登录</span></router-link
          >
          <router-link :to="{ name: 'register' }">免费注册</router-link>
        </div>
        <div class="user_center" v-else>
          <router-link :to="{ name: 'centerindex' }">{{
            nickname
          }}</router-link>
        </div>
        <div class="msg">
          <router-link :to="{ name: 'message' }">
            <img src="../../static/msg_icon.png" />
            <div class="red" v-if="num > 0">{{ num | indexsum }}</div>
          </router-link>
        </div>
        <div style="color: #1395FF;padding-left:0.1rem">
          <router-link :to="{ name: 'message' }">消息</router-link>
        </div>
      </div>
    </div>
    <div class="container head hidden-xs">
      <div class="head_logo">
        <router-link :to="{ name: 'index' }"
          ><img src="../../static/logo.png"
        /></router-link>
      </div>
      <div class="head_nav">
        <div class="nav_item nav_item_ac">
          <router-link :to="{ name: 'index' }">首页</router-link>
        </div>
        <div class="nav_item">
          <router-link :to="{ name: 'companyregister' }">公司注册</router-link>
        </div>
        <div class="nav_item">
          <router-link :to="{ name: 'agency' }">代理记账</router-link>
        </div>
        <div class="nav_item">
          <router-link :to="{ name: 'logoregister' }">商标注册</router-link>
        </div>
        <div class="nav_item">
          <router-link :to="{ name: 'news' }">新闻资讯</router-link>
        </div>
        <div class="nav_item">
          <router-link :to="{ name: 'circle_index' }">圈子</router-link>
        </div>
      </div>
    </div>
    <div class="mobile_head hidden-lg hidden-md top">
      <div class="top_location" v-if="index_show">
        <img class="loc_icon" src="../../static/loca.png" />{{
          city.substring(0, 2)
        }}
        <span class="change_city" @click="selectcity">切换城市 </span>
      </div>
      <div class="m_title">{{ mobile_title }}</div>

      <div class="head-right" @click="gomsg" v-if="index_show">
        <div class="tip" v-if="num > 0">{{ num | indexsum }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getindexmsgnum } from "../view/api/api"; //引入api里面定义的方法
export default {
  inject: ["reload"],
  props: {
    index_show: {
      type: Boolean,
      default: false
    },
    mobile_title: {
      type: String,
      default: "马上创业网"
    }
  },
  data() {
    return {
      indexmsgtimer: null,
      num: 0,
      token: localStorage.getItem("sessionToken"),
      nickname: localStorage.getItem("nickname"),
      city: localStorage.getItem("city") ? localStorage.getItem("city") : "上海"
    };
  },
  async mounted() {
    var parm = {
      uid: localStorage.getItem("userId")
    };
    var indexmsgnum = await getindexmsgnum(parm);
    this.num = indexmsgnum.data.data.indexmsgnum;

    this.indextimedemo();
  },
  destroyed() {
    this.indexmsgtimer && this.clearindexTimer();
  },
  methods: {
    selectcity() {
      this.$router.push({
        path: "city"
      });
    },
    gomsg() {
      this.$router.push({
        path: "message"
      });
    },
    async getmyindexmsgnum() {
          var parm = {
            uid: localStorage.getItem("userId")
          };
          var indexmsgnum = await getindexmsgnum(parm);
          this.num = indexmsgnum.data.data.indexmsgnum;
    },
			indextimedemo() {
				this.indexmsgtimer = setInterval(() => {
			
					this.getmyindexmsgnum()
			
				}, 1500)
			},
			clearindexTimer() {
				clearInterval(this.indexmsgtimer);
				this.indexmsgtimer = null;
			},
  }
};
</script>

<style lang="less" scoped>
.head_line {
  margin-bottom: 0rem;
  padding-bottom: 0.2rem;
  border-bottom: 0.02rem solid #ccc;
  @media (max-width: 991px) {
    border-bottom: 0rem solid #ccc;
  }
}
.menu {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1.2rem;
  background: #fff;
  z-index: 2;
  display: flex;
  justify-content: space-around;
  .m_item {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .m_icon {
      img {
        width: 0.5rem;
        height: 0.5rem;
      }
    }
    .m_text {
      font-size: 0.2rem;
    }
  }
}
.mobile_head {
  height: 0.88rem;
  line-height: 0.88rem;
  font-size: 0.32rem;
  font-weight: bolder;
  text-align: center;
  color: #000;
  position: relative;
  align-items: center;
  //box-shadow: 0 0.02rem 0.07rem 0 rgba(0, 0, 0, 0.05);
  .m_title {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
  }
  .head-right {
    width: 20%;
    height: 0.42rem;
    position: relative;
    background: url(../../static/index/kv/head-icon-2.png) right center
      no-repeat;
    background-size: 0.42rem 0.41rem;
    position: relative;

    .tip {
      position: absolute;
      top: -0.1rem;
      right: -0.1rem;
      width: 0.3rem;
      height: 0.3rem;
      border-radius: 50%;
      background-color: #ff545a;
      font-size: 0.2rem;
      line-height: 0.3rem;
      color: #ffffff;
      text-align: center;
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/head_2.vue